import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import { breakpoints } from '@utils/breakpoints'

import Icon from '@components/icon/Icons'
import theme from '@theme/Theme'

const IconsSection = () => {
  return (
    <Section>
      <SectionTitle>Icons</SectionTitle>
      <IconRow>
        {icons.map((name) => (
          <IconContainer key={name}>
            <Icon name={name} size={50} />
            <IconLabel>{name}</IconLabel>
          </IconContainer>
        ))}
      </IconRow>
      <IconRow dark>
        {icons.map((name) => (
          <IconContainer key={name}>
            <Icon name={name} size={15} color={theme.colors.background} />
          </IconContainer>
        ))}
      </IconRow>
    </Section>
  )
}

export default IconsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;

  @media only screen and (min-width: ${breakpoints.phone}px) {
    padding: 24px 48px;
  }
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const IconRow = styled(View)<{ dark?: boolean }>`
  flex-flow: row wrap;
  ${(props) => props.dark && `background-color: ${props.theme.colors.primary};`}
`
const IconContainer = styled(View)`
  margin: 15px;
  align-items: center;
`
const IconLabel = styled(Text)`
  text-align: center;
  ${(props) => props.theme.fonts.Caption2};
`

const icons: IconName[] = [
  'add',
  'add-circle',
  'apartment',
  'arrow',
  'arrow-down',
  'arrow-left',
  'arrow-up',
  'batiment',
  'calendar',
  'cancel',
  'charpenter',
  'checkbox_checked',
  'checkbox_unchecked',
  'checked',
  'check-list',
  'clean',
  'close',
  'comment',
  'connectivity',
  'delete',
  'divers-work',
  'document',
  'done',
  'dot',
  'download',
  'edit',
  'electric',
  'elevator',
  'email',
  'fav',
  'filter',
  'folder',
  'full-arrow',
  'gps',
  'hammer',
  'image',
  'incident_clock',
  'incident_done',
  'incident_euro',
  'incident_key',
  'incident_minus',
  'incident_right-arrow',
  'incident_pause',
  'incident_cross',
  'info',
  'key',
  'location',
  'love-filled',
  'mail',
  'map',
  'mobile',
  'painting',
  'phone',
  'photo',
  'prestataire',
  'problem',
  'profil',
  'radio_empty',
  'radio_filled',
  'redo',
  'search',
  'send',
  'settings',
  'sms-failed',
  'sync',
  'tab_checklist',
  'tab_edl',
  'tab_profile',
  'tab_quality',
  'timer',
  'undo',
  'unvisibility',
  'upload',
  'verified',
  'viparis',
  'visibility',
  'water',
  'window',
]
